import React from 'react';
import { useProject } from '../../hooks/useProject';
import { useProjectPageMount } from '../../hooks/useProjectPageMount';
import { useProjectIdFromRoute } from '../../hooks/useProjectIdFromRoute';
import { Tabs } from '../../components/Tabs';
import { PageHeader } from '../../components/PageHeader';
import { Breadcrumb } from '../../components/Breadcrumb';
import { DetailTab } from './DetailTab';
import { BillingTab } from './BillingTab';
import { UsersTab } from './UsersTab';
import { PasswordsTab } from './PasswordsTab';
import { RolesTab } from './RolesTab';
import { AuditTab } from './AuditTab';
import { ExportsTab } from './ExportsTab';
import { RemoteCollectionTab } from './RemoteCollectionTab';
import { FormsTab } from './FormsTab';
import { SearchTermsTab } from './SearchTermsTab';
import { MetadataTab } from './MetadataTab';
import { LoadingPlaceholder } from '../../components/LoadingPlaceholder';

export function ProjectAdminPage() {
  const projectId = useProjectIdFromRoute();
  const { data: project, isLoading } = useProject(projectId);

  useProjectPageMount(project, 'projects', 'admin');

  const status = project?.status;
  const isHibernateOrPurged = status === 'hibernate' || status === 'purged';
  const isPurged = status === 'purged';

  const tabs = [
    { id: 'detail', heading: 'Detail', content: <DetailTab projectId={projectId} /> },
    { id: 'billing', heading: 'Billing', content: <BillingTab projectId={projectId} /> },
    { id: 'users', heading: 'Users', content: <UsersTab projectId={projectId} /> },
    { id: 'passwords', heading: 'Passwords', content: <PasswordsTab projectId={projectId} /> },
    { id: 'metadata', heading: 'Metadata', disabled: isHibernateOrPurged, content: <MetadataTab projectId={projectId} /> },
    { id: 'forms', heading: 'Forms', disabled: isHibernateOrPurged, content: <FormsTab projectId={projectId} /> },
    { id: 'roles', heading: 'Roles', disabled: isHibernateOrPurged, content: <RolesTab projectId={projectId} /> },
    { id: 'search-terms', heading: 'Search Terms', disabled: isHibernateOrPurged, content: <SearchTermsTab projectId={projectId} /> },
    { id: 'exports', heading: 'Exports', disabled: isHibernateOrPurged, content: <ExportsTab projectId={projectId} /> },
    { id: 'audit', heading: 'Audit', disabled: isPurged, content: <AuditTab projectId={projectId} /> },
    { id: 'remote-collection', heading: 'Remote Collection', disabled: isPurged, content: <RemoteCollectionTab projectId={projectId} /> },
  ];

  return (
    <>
      {isLoading && <LoadingPlaceholder label="Loading project…" />}
      {project && (
        <>
          <PageHeader
            project={project}
            title={`${project.name} Admin`}
            helpUrl="https://indexedio.zendesk.com/hc/en-us/sections/115000601133-Admin"
          />
          <Breadcrumb items={[
            { label: 'Projects', href: '/project' },
            ...(!isHibernateOrPurged
              ? [{ label: project.name, href: `/project/${projectId}` }]
              : [{ label: project.name }]),
            { label: 'Admin' },
          ]} />

          <Tabs tabs={tabs} defaultTab="detail" />
        </>
      )}
    </>
  );
}
